import { render } from "./Login.vue?vue&type=template&id=664ec4be&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=664ec4be&scoped=true&lang=css"

import exportComponent from "/Users/fikri/Work/PRiADI/code/priadi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664ec4be"]])

export default __exports__